import QueryTags from '../../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react'
import { MySessionsReq, MySessionsRes, UserSession } from './types'

const adminPath = '/administration/api'

const sessionsEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>,
    QueryTags,
    'data'
  >
) => ({
  getMySessions: builder.query<MySessionsRes, MySessionsReq>({
    query: ({ channel, pageNumber = 0, pageSize = 20, status }) => {
      const params = new URLSearchParams({
        pageNumber: `${pageNumber}`,
        pageSize: `${pageSize}`,
      })
      if (status) {
        params.set('status', status)
      }
      return {
        url: `${adminPath}/me/sessions?${params.toString()}`,
        method: 'GET',
      }
    },
    providesTags: ['userSessions'],
  }),

  getSessionById: builder.query<UserSession, string>({
    query: (sessionId) => {
      return {
        url: `${adminPath}/me/sessions/${sessionId}`,
        method: 'GET',
      }
    },
    providesTags: ['userSessions'],
  }),
  getCurrentSession: builder.query<UserSession, void>({
    query: () => {
      return {
        url: `${adminPath}/me/sessions/current`,
        method: 'GET',
      }
    },
    providesTags: ['userSessions'],
  }),
  terminateAllSessions: builder.mutation<any, any>({
    query: (body) => ({
      url: `${adminPath}/me/sessions/bulk-revoke`,
      method: 'POST',
      body,
    }),
    invalidatesTags: ['userSessions'],
  }),
  terminateOneSession: builder.mutation<any, any>({
    query: (sessionId) => ({
      url: `${adminPath}/me/sessions/${sessionId}/revoke`,
      method: 'POST',
    }),
    invalidatesTags: ['userSessions'],
  }),
})

export default sessionsEndpoints
